import React from "react";
import Meter from "./Meter";
import Reveal from "./Reveal";
import SectionHeading from "./SectionHeading";
import { education, hobbies, languages, references } from "../data/resume";

const Block = ({ title, children, delay }) => (
    <Reveal delay={delay} className="border-t border-fg/10 pt-5">
        <h3 className="label text-fg">{title}</h3>
        <div className="mt-5">{children}</div>
    </Reveal>
);

const Education = () => (
    <section id="education" aria-labelledby="education-title" className="py-10 md:py-14">
        <SectionHeading id="education-title" index="04" label="Background" title="Education &" accent="More" />

        <div className="mt-8 grid gap-x-10 gap-y-10 md:mt-10 md:grid-cols-2">
            <Block title="Education">
                {education.map((item) => (
                    <div key={item.program}>
                        <p className="text-[1.6rem] font-extrabold leading-[1.02] tracking-[-0.01em] stretch-condensed">{item.program}</p>
                        <p className="mt-2 font-medium text-accent-text">{item.school}</p>
                        <p className="label mt-2.5 tabular-nums">
                            {item.period} <span className="text-subtle">|</span> {item.location}
                        </p>
                    </div>
                ))}
            </Block>

            <Block title="Languages" delay={90}>
                <ul className="space-y-3">
                    {languages.map((language) => (
                        <li key={language.name} className="flex items-center justify-between gap-4">
                            <span>{language.name}</span>
                            <Meter level={language.level} label={`${language.name} proficiency`} />
                        </li>
                    ))}
                </ul>
            </Block>

            <Block title="References">
                <ul className="space-y-4">
                    {references.map((reference) => (
                        <li key={reference.name}>
                            <p className="font-semibold">{reference.name}</p>
                            <p className="text-[15px] text-muted">
                                <span className="font-serif text-[1.05rem] italic">{reference.role}</span>, {reference.organization}
                            </p>
                        </li>
                    ))}
                </ul>
                <p className="label mt-5 text-subtle">Contact details available on request</p>
            </Block>

            <Block title="Hobbies" delay={90}>
                <ul className="space-y-2">
                    {hobbies.map((hobby) => (
                        <li key={hobby} className="flex gap-3 text-muted">
                            <span aria-hidden="true" className="text-accent-text">–</span>
                            {hobby}
                        </li>
                    ))}
                </ul>
            </Block>
        </div>
    </section>
);

export default Education;
